import { isAxiosError } from 'axios'

import { bridgelessRestApiClient } from '@/api/clients'
import { buildPaginationParams } from '@/helpers'
import { Nft, PaginationParams, PaginationResponse } from '@/types'

export interface NftListResponse {
  nfts: Nft[]
  pagination: PaginationResponse
}

export async function fetchNftList(
  pagination?: PaginationParams,
): Promise<NftListResponse> {
  const { data } = await bridgelessRestApiClient.get<{
    nft: Nft[] // HACK: should be 'nfts' according to the docs, but the actual response uses 'nft'
    pagination: PaginationResponse
  }>(`/cosmos/nft/nfts`, {
    params: buildPaginationParams(pagination),
  })

  return {
    nfts: data.nft,
    pagination: data.pagination,
  }
}

export async function fetchNftListByOwner(
  ownerAddress: string,
  pagination?: PaginationParams,
): Promise<NftListResponse> {
  const { data } = await bridgelessRestApiClient.get<{
    nft: Nft[] // HACK: should be 'nfts' according to the docs, but the actual response uses 'nft'
    pagination: PaginationResponse
  }>(`/cosmos/nft/owners/${ownerAddress}/nfts`, {
    params: buildPaginationParams(pagination),
  })
  return {
    nfts: data.nft,
    pagination: data.pagination,
  }
}

export async function fetchNft(nftAddress: string): Promise<Nft | null> {
  try {
    const { data } = await bridgelessRestApiClient.get<{ nft: Nft }>(
      `/cosmos/nft/nft/${nftAddress}`,
    )
    return data.nft
  } catch (error) {
    if (isNftNotFoundError(error)) return null
    throw error
  }
}

function isNftNotFoundError(error: unknown): boolean {
  if (!isAxiosError<{ message?: string }>(error)) return false
  return Boolean(error.response?.data?.message?.includes('NFT not found'))
}

export interface NftModuleParams {
  module_admin: string
  bond_denom: string
  prefix: string
  nft_sequence: string
  total_vesting_time: string
  vesting_period: string
  nft_token_amount: string
  batch_size: string
  batch_index: string
}

interface NftModuleParamsResponse {
  params: NftModuleParams
}

export async function fetchNftModuleParams(): Promise<NftModuleParams> {
  const { data } =
    await bridgelessRestApiClient.get<NftModuleParamsResponse>(
      '/cosmos/nft/params',
    )

  return data.params
}
